'use client';

import Script from 'next/script';
import { GPT_SCRIPT_URL, SITE } from '@/app/constants';
import { useUserNexus } from '@/app/hooks';
import { initInterstitialSlot } from './utils/init-interstitial';

export const GPTScriptLoader = () => {
  const { isMissionWatchAdCredit } = useUserNexus();
  const isEligible = SITE === 'global' && isMissionWatchAdCredit;

  return (
    <>
      {isEligible && (
        <Script
          src={GPT_SCRIPT_URL}
          strategy="afterInteractive"
          onLoad={() => {
            initInterstitialSlot();
          }}
        />
      )}
    </>
  );
};
